.container {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  gap: 0.4rem;
  flex-shrink: 1.5;
  flex-grow: 0;
  justify-content: space-between;
  // min-width: 18rem;
}

.filler {
  min-width: 0;
  display: flex;
  flex-grow: 1;
}
